import fetcher from '../fetcher';

/**
 * Params for searching plakats
 */
export type SearchPlakatParams = {
	pagination: {
		pageSize: number;
		pageNumber: number;
	};
	search?: {
		by: string;
		value: string;
	};
	date?: string; // Date filter for released date
};

/**
 * Item type for a plakat in the list
 */
export type SearchPlakatItem = {
	id?: number;
	purchaseOrderId?: number;
	purchaseOrderNo?: string;
	purchaseOrderDate?: string;
	purchaseOrderStatus?: string;
	customerId?: string;
	customerName?: string;
	unitType?: string;
	plakatNo?: string;
	releasedDate?: string;
	frmName?: string;
	fbdhName?: string;
	isChecked: boolean;
	isAllowAction: boolean;
};

/**
 * Response type for searching plakats
 */
export type SearchPlakatResponse = {
	totalCount: number;
	pageSize: number;
	currentPage: number;
	totalPages: number;
	items?: SearchPlakatItem[];
};

/**
 * Submit plakat request item type
 */
export type SubmitPlakatItemRequest = {
	id: number;
	releasedDate: string;
};

/**
 * Submit plakat request type
 */
export type SubmitPlakatRequest = {
	plakats: SubmitPlakatItemRequest[];
};

/**
 * Submit plakat response type
 */
export type SubmitPlakatResponse = {
	status: string;
	data: {
		message: string;
	};
	metadata: null;
};

/**
 * Search plakats via API
 * @param params - Search params
 * @returns Promise with search result
 */
export const searchPlakats = (params: SearchPlakatParams) => {
	return fetcher<SearchPlakatResponse>({
		api: '/plakats/search',
		method: 'POST',
		body: params,
	});
};

/**
 * Submit plakat for processing
 * @param request - Submit request with plakat IDs
 * @returns Promise with submit result
 */
export const submitPlakats = (request: SubmitPlakatRequest) => {
	return fetcher<{
		message: string;
	}>({
		api: '/plakats/submit',
		method: 'POST',
		body: request,
	});
};

/**
 * Get plakat todo count
 * @returns Promise with plakat todo count
 */
export const getPlakatTodoCount = () => {
	return fetcher<number>({
		api: '/plakats/get-things-todo',
		method: 'POST',
	});
};
